import { useContext } from "react";
import { CashdeskContext } from "../contexts/cashdeskContext";

export const useCashdesk = () => {
  const context = useContext(CashdeskContext);

  return context;
};
